import { render, staticRenderFns } from "./model_2.vue?vue&type=template&id=0539ef65"
import script from "./model_2.vue?vue&type=script&lang=js"
export * from "./model_2.vue?vue&type=script&lang=js"
import style0 from "./model_2.vue?vue&type=style&index=0&id=0539ef65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports